import { Breadcrumbs, Link, Stack, Typography } from '@mui/material'
import React from 'react'
import { Link as RouterLink } from 'react-router-dom'

import Icon from 'components/Icon'
import { useGetTestSuitesUrls } from 'components/test-suites/hooks/use-get-test-suites-urls'
import { muiTheme } from 'mui-theme'

const TestSuiteRoot: React.FC<{ isLink?: boolean }> = ({ isLink }) => {
  return (
    <Typography sx={{ color: isLink ? 'inherit' : 'text.primary' }}>
      <Icon css={{ marginRight: muiTheme.spacing(1) }} icon="books" />
      Test Suites
    </Typography>
  )
}

export const TestSuitesBreadcrumbs: React.FC<{
  children?: React.ReactNode
  onRootPage?: boolean
}> = ({ children, onRootPage }) => {
  const testSuitesUrls = useGetTestSuitesUrls()

  return (
    <Breadcrumbs aria-label="breadcrumb">
      <Stack alignItems="center" direction="row">
        {onRootPage ? (
          <TestSuiteRoot />
        ) : (
          <Link
            component={RouterLink}
            sx={{ display: 'flex', alignItems: 'center' }}
            to={testSuitesUrls.base()}
            underline="hover"
          >
            <TestSuiteRoot isLink />
          </Link>
        )}
      </Stack>
      {children ?? null}
    </Breadcrumbs>
  )
}
